import axios from 'axios';
import { verifyUserRoleBegin, verifyUserRoleSuccess, verifyUserRoleFailure } from '../IndustryAssist/VerifyUserRoleAction';

export const verifyIndustryAssistUser = (webappurlForms, accessToken, organisationArn) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
       
        dispatch(verifyUserRoleBegin());
        return axios.post(webappurlForms + `/api/myCASA/Forms/verifyIndustryAssistUser/${organisationArn}/v1`, null, options)
            .then(response => {
                if (response.data.wasSuccessful && response.data.individualVerified && !response.data.errors) {
                    return dispatch(verifyUserRoleSuccess(response.data));
                }
                else {
                    return dispatch(verifyUserRoleFailure(response.data.errors));
                }
            })
            .catch(error => {
                return dispatch(verifyUserRoleFailure(error.response ? error.response.data.errors : error));
            });
    };
}
